"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = QuestionContainer;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _ArrowUpwardOutlined = _interopRequireDefault(require("@material-ui/icons/ArrowUpwardOutlined"));

var _ArrowDownwardOutlined = _interopRequireDefault(require("@material-ui/icons/ArrowDownwardOutlined"));

var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));

var _styles = require("@material-ui/core/styles");

var _Questions = require("./Questions");

var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));

var _schemaReducer = require("../state/schema-reducer");

var _uiSchemaReducer = require("../state/ui-schema-reducer");

var _schemaStore = require("../state/schema-store");

var _uiSchemaStore = require("../state/ui-schema-store");

var _languageStore = require("../state/language-store");

var _RadioButtonChecked = _interopRequireDefault(require("@material-ui/icons/RadioButtonChecked"));

var _CheckBox = _interopRequireDefault(require("@material-ui/icons/CheckBox"));

var _Subject = _interopRequireDefault(require("@material-ui/icons/Subject"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    paper: {
      padding: theme.spacing(2),
      border: "".concat(theme.palette.primary.main, " solid 1px")
    },
    cardHeader: {
      cursor: "pointer",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%"
    },
    collapsableContent: {
      paddingLeft: "10px",
      paddingRight: "10px",
      width: "100%"
    },
    iconLabel: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    icon: {
      marginRight: "5px"
    }
  };
});

function QuestionContainer(_ref) {
  var _uiSchema$index, _uiSchema$index$uiOp, _context;

  var question = _ref.question,
      index = _ref.index,
      questionUi = _ref.questionUi,
      collapseAll = _ref.collapseAll;

  var _useContext = (0, _react.useContext)(_schemaStore.SchemaContext),
      _useContext2 = (0, _slicedToArray2.default)(_useContext, 2),
      schema = _useContext2[0],
      schemaDispatch = _useContext2[1];

  var _useContext3 = (0, _react.useContext)(_uiSchemaStore.UiSchemaContext),
      _useContext4 = (0, _slicedToArray2.default)(_useContext3, 2),
      uiSchema = _useContext4[0],
      uiSchemaDispatch = _useContext4[1];

  var _useContext5 = (0, _react.useContext)(_languageStore.LanguageContext),
      _useContext6 = (0, _slicedToArray2.default)(_useContext5, 1),
      language = _useContext6[0];

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var classes = useStyles(); // Collapse all should always set expand to false
  // use ref to track first rener as first render
  // expand shoul bd true

  var firstUpdate = (0, _react.useRef)(true);
  (0, _react.useEffect)(function () {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    setExpanded(false);
  }, [collapseAll]);

  function moveItem(e, direction, index) {
    e.stopPropagation();
    schemaDispatch({
      type: _schemaReducer.TYPES.MOVE_QUESTION,
      payload: {
        direction: direction,
        index: index
      }
    });
    uiSchemaDispatch({
      type: _uiSchemaReducer.TYPES.MOVE,
      payload: {
        direction: direction,
        index: index
      }
    });
  }

  function removeItem(e, i) {
    e.stopPropagation();
    schemaDispatch({
      type: _schemaReducer.TYPES.DELETE,
      payload: i
    });
    uiSchemaDispatch({
      type: _uiSchemaReducer.TYPES.DELETE,
      payload: i
    });
  }

  var orientation = (uiSchema === null || uiSchema === void 0 ? void 0 : (_uiSchema$index = uiSchema[index]) === null || _uiSchema$index === void 0 ? void 0 : (_uiSchema$index$uiOp = _uiSchema$index["ui:options"]) === null || _uiSchema$index$uiOp === void 0 ? void 0 : _uiSchema$index$uiOp.inline) || false;
  var required = (schema === null || schema === void 0 ? void 0 : schema.required) || [];
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Paper, {
    className: classes.paper
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    className: classes.cardHeader,
    onClick: function onClick() {
      return setExpanded(!expanded);
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    className: classes.iconLabel
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    className: classes.icon
  }, (0, _uiSchemaReducer.getQuestionType)(questionUi["ui:widget"]) === _uiSchemaReducer.QUESTION_TYPES.OPEN_ENDED && /*#__PURE__*/_react.default.createElement(_Subject.default, null), (0, _uiSchemaReducer.getQuestionType)(questionUi["ui:widget"]) === _uiSchemaReducer.QUESTION_TYPES.RADIO && /*#__PURE__*/_react.default.createElement(_RadioButtonChecked.default, null), (0, _uiSchemaReducer.getQuestionType)(questionUi["ui:widget"]) === _uiSchemaReducer.QUESTION_TYPES.CHECKBOX && /*#__PURE__*/_react.default.createElement(_CheckBox.default, null)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6"
  }, question.title || (0, _concat.default)(_context = "".concat(language.questionTitleLabel, " ")).call(_context, index + 1)))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    disabled: index === 0 ? true : false,
    onClick: function onClick(e) {
      return moveItem(e, _schemaReducer.DIRECTIONS.UP, index);
    }
  }, /*#__PURE__*/_react.default.createElement(_ArrowUpwardOutlined.default, null)), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    disabled: index + 1 >= (0, _keys.default)(schema.properties).length,
    onClick: function onClick(e) {
      return moveItem(e, _schemaReducer.DIRECTIONS.DOWN, index);
    }
  }, /*#__PURE__*/_react.default.createElement(_ArrowDownwardOutlined.default, null)), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: function onClick(e) {
      return removeItem(e, index);
    }
  }, /*#__PURE__*/_react.default.createElement(_Delete.default, {
    color: "primary"
  }))))), /*#__PURE__*/_react.default.createElement(_Collapse.default, {
    in: expanded,
    timeout: "auto",
    unmountOnExit: true,
    className: classes.collapsableContent
  }, (0, _uiSchemaReducer.getQuestionType)(questionUi["ui:widget"]) === _uiSchemaReducer.QUESTION_TYPES.OPEN_ENDED && /*#__PURE__*/_react.default.createElement(_Questions.OpenEndedQuestion, {
    id: index
  }), (0, _uiSchemaReducer.getQuestionType)(questionUi["ui:widget"]) === _uiSchemaReducer.QUESTION_TYPES.RADIO && /*#__PURE__*/_react.default.createElement(_Questions.RadioButtonQuestion, {
    id: index
  }), (0, _uiSchemaReducer.getQuestionType)(questionUi["ui:widget"]) === _uiSchemaReducer.QUESTION_TYPES.CHECKBOX && /*#__PURE__*/_react.default.createElement(_Questions.CheckboxQuestion, {
    id: index
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/_react.default.createElement(_core.Switch, {
      checked: (0, _includes.default)(required).call(required, index.toString()),
      onChange: function onChange(e) {
        return schemaDispatch({
          type: _schemaReducer.TYPES.MARK_QUESTION_REQUIRED,
          payload: {
            index: index,
            required: e.target.checked
          }
        });
      }
    }),
    label: language.questionContainerRequiredLabel
  }), (questionUi["ui:widget"] === "radio" || questionUi["ui:widget"] === "checkboxes") && /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      checked: orientation,
      onChange: function onChange(e) {
        return uiSchemaDispatch({
          type: _uiSchemaReducer.TYPES.MARK_QUESTION_ORIENTATION,
          payload: {
            index: index,
            checked: e.target.checked
          }
        });
      },
      name: "checkedB",
      color: "primary"
    }),
    label: language.questionContainerHorizontalLabel
  })))));
}